import CustomScroll from "@src/component/customScroll"
import { goto } from "@src/route";
import { loadList, checkQuaStatus, loadReason } from "@src/service/ownService";
import { Toast } from "antd-mobile";
import { memo, useEffect, useState } from "react"
import { getQueryParams } from "@src/util";
import "./index.scss"
type Model = {
  show: boolean,
  content?: string,
  isSolo?: any
}
const stateList = {
  financePlanStatus: [ //* 金融方案状态
    {
      value: 0,
      name: "待销售下发金融方案",
    },
    {
      value: 1,
      name: "已驳回",
    },
    {
      value: 2,
      name: "待确认",
    },
    {
      value: 3,
      name: "已拒绝",
    },
    {
      value: 4,
      name: "待审核",
    },
    {
      value: 5,
      name: "审核通过",
    },
    {
      value: 6,
      name: "已结束",
    },
    {
      value: 7,
      name: "已终止",
    },
    {
      value: 88,
      name: "已过期",
    },
  ],
  contractInfoStatus: [ //* 融租合同状态
    {
      value: 0,
      name: "待销售推送",
    },
    {
      value: 1,
      name: "待签字",
    },
    {
      value: 2,
      name: "已拒绝",
    },
    {
      value: 3,
      name: "已签字",
    },
    {
      value: 4,
      name: "待销售推送",
    },
    {
      value: 88,
      name: "已过期",
    },
  ],
  grantApplyStatus: [ //* 放款申请状态
    {
      value: 0,
      name: "未提交",
    },
    {
      value: 1,
      name: "待审核",
    },
    {
      value: 2,
      name: "已通过",
    },
    {
      value: 3,
      name: "已驳回",
    },
    {
      value: 4,
      name: "已拒绝",
    },
    {
      value: 6,
      name: "已结束",
    },
    {
      value: 7,
      name: "已终止",
    },
    {
      value: 88,
      name: "已过期",
    },
  ]
}
const FinanSchedule = () => {
  const [showModel, setShowModel] = useState<Model>({ show: false })
  const [data, setData] = useState<{ total: number, rows: any[] }>();
  const urlObj = getQueryParams()
  const info = {
    company: '润雨同舟（深圳）融资租赁有限公司',
    bank: '招商银行成都分行府城大道支行',
    account: '128910318410305'
  }
  useEffect(() => {
    switch (urlObj.status) {
      case 'financePlanStatus':
        document.title = "金融方案"
        break;
      case 'contractInfoStatus':
        document.title = "融租合同"
        break;
      case 'grantApplyStatus':
        document.title = "放款申请"
        break;
      default:
        break;
    }

  }, [])

  useEffect(() => {
    getList();
  }, [])
  // 获取列表数据
  const getList = async () => {
    const obj = {
      [urlObj.status]: "-1",
      pages: 1,
      rows: 100
    }
    try {
      const list = await loadList(obj);
      setData(list);
    } catch (err: any) {
      Toast.show(err?.errmsg)
    }
  }
  // 获取终止原因
  const getReason = (item: any) => {
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    loadReason("/api/loaning/getReason", {
      loaningInfoId: item.id,
      type: urlObj.type
    }).then((res) => {
      Toast.clear()
      if (res.errcode === 0) {
        setShowModel({ show: true, content: res.data })
      } else {
        Toast.show(res?.errmsg || '操作异常')
      }
    }).catch((err) => {
      Toast.show(err?.errmsg || '原因查询失败！')
    })
  };
  // 复制
  const copy = (str: string) => {
    const createInput = document.createElement("input");
    createInput.value = str;
    document.body.appendChild(createInput);
    createInput.select();
    document.execCommand("Copy"); // document执行复制操作
    createInput.remove();
    Toast.show("复制成功");
  }
  // 获取状态名称
  const formatStatus = (status: number) => {
    const statusList = stateList[urlObj.status]
    if (statusList) {
      const index = statusList.findIndex((s: any) => s.value === status);
      if (index > -1) {
        return statusList[index].name;
      } else {
        return "";
      }
    }
  };

  // 重新申请
  const reApply = (item: any, status: boolean) => {
    let description = "";
    let isSolo;
    if (status) { 	//* 已终止
      description += "重新申请后需从金融方案确认开始走流程，是否确定重新申请？";
      isSolo = false;
    } else { //* 已结束
      description += "订单已结束，请点击【资格预审】重新提交资料申请";
      isSolo = true;
    }
    setShowModel({ show: true, content: description, isSolo: isSolo ? null : item.id })
  };
  /**
   * 金额格式化
   * @param s 传入数字
   * @param n 保留几位小数
   * @returns 
   */
  const fmoney = (s: string, n: number) => {
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    const l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
  }

  // 跳转金融方案详情
  const goToFinancialProject = (item: any) => {
    goto("/order/applyDetail", { loanid: item?.id, status: item.financePlanStatus, type: 'finanPlan' })
  }
  // 跳转融租合同
  const goToRentContract = (item: any) => {
    goto("/order/loanDetail", { loanid: item?.id, status: item.contractInfoStatus, type: 'contractInfo' })
  }

  return (<div className="page bottomFit FinanSchedule Contract">
    <CustomScroll>
      {urlObj.status === "contractInfoStatus" && <div className="title-box">
        <div className="dotted-line">融资租赁服务提供对公账户信息：</div>
        <div>公司名称：{info.company}
          <span className="copy" onClick={() => copy(info.company)}>复制</span>
        </div>
        <div>开户行：{info.bank}
          <span className="copy" onClick={() => copy(info.bank)}>复制</span>
        </div>
        <div>公司对公账号：{info.account}
          <span className="copy" onClick={() => copy(info.account)}>复制</span>
        </div>
        <div className="remark">提示：银行转账输入时，公司名称的括号需在英文状态下输入，否则会转账失败</div>
      </div>}
      <div className="apply-num">共{data?.total}笔</div>
      <div>
        {/* <div className="apply-box">
          <div className="box-title">
            <p>单号：<span>11111</span></p>
            <p>{formatStatus(1)}</p>
          </div>
          <div className="box-content">
            <div className="content-text">
              <h2>￥{fmoney('1444444', 2)}</h2>
            </div>
            <div className="content-icon"></div>
          </div>
          <div className="box-btn">
            <div>确认金融方案</div>
          </div>
        </div> */}
        {
          data?.rows && data?.rows.map(_ele => {
            let renderButton: any = "";
            if (urlObj.status == 'financePlanStatus') {
              switch (_ele[urlObj.status]) {
                case 2:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        Toast.show({
                          icon: 'loading',
                          content: '加载中…',
                          duration: 0,
                          maskClickable: false
                        })
                        checkQuaStatus().then(res => {
                          Toast.clear()
                          const { code } = res || {};
                          if (code === 999) {
                            Toast.show(res.msg)
                            return
                          }
                          goToFinancialProject(_ele)
                        }).catch((err) => {
                          Toast.show(err?.errmsg || '申请状态查询失败！')
                        })
                        e.stopPropagation();
                      }}>确认金融方案</div>
                    </>
                  ); break;
                case 3:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        goToFinancialProject(_ele)
                        e.stopPropagation();
                      }}>查看金融方案</div>
                    </>
                  ); break;
                case 6:
                  renderButton = (
                    <div onClick={(e) => {
                      getReason(_ele)
                      e.stopPropagation();
                    }}>查看原因</div>
                  ); break;
                case 7:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        getReason(_ele)
                        e.stopPropagation();
                      }}>查看原因</div>
                      <div onClick={(e) => {
                        reApply(_ele, false)
                        e.stopPropagation();
                      }}>重新申请</div>
                    </>
                  ); break;
              }
            } else if (urlObj.status === "contractInfoStatus") { // 融租合同
              switch (_ele[urlObj.status]) {
                case 0:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        goToFinancialProject(_ele)
                        e.stopPropagation();
                      }}>查看金融方案</div>
                    </>
                  ); break;
                case 1:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        goToFinancialProject(_ele)
                        e.stopPropagation();
                      }}>查看金融方案</div>
                    </>
                  ); break;
                case 2:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        goToFinancialProject(_ele)
                        e.stopPropagation();
                      }}>查看金融方案</div>
                      <div onClick={(e) => {
                        goToRentContract(_ele)
                        e.stopPropagation();
                      }}>查看融租合同</div>
                    </>
                  ); break;
                case 6:
                  renderButton = (
                    <div onClick={(e) => {
                      getReason(_ele)
                      e.stopPropagation();
                    }}>查看原因</div>
                  ); break;
                case 7:
                  renderButton = (
                    <>
                      <div onClick={(e) => {
                        getReason(_ele)
                        e.stopPropagation();
                      }}>查看原因</div>
                      <div onClick={(e) => {
                        reApply(_ele, false)
                        e.stopPropagation();
                      }}>重新申请</div>
                    </>
                  ); break;
              }
            } else if (urlObj.status === "grantApplyStatus") {  // 放款申请
              if ([0, 1, 2, 3, 4].includes(_ele[urlObj.status])) {
                renderButton = (
                  <>
                    <div onClick={(e) => {
                      goToFinancialProject(_ele)
                      e.stopPropagation();
                    }}>查看金融方案</div>
                    <div onClick={(e) => {
                      goToRentContract(_ele)
                      e.stopPropagation();
                    }}>查看融租合同</div>
                  </>
                );
              } else if ([6, 7].includes(_ele[urlObj.status])) {
                renderButton = (
                  <>
                    <div onClick={(e) => {
                      getReason(_ele)
                      e.stopPropagation();
                    }}>查看原因</div>
                    <div onClick={(e) => {
                      reApply(_ele, false)
                      e.stopPropagation();
                    }}>重新申请</div>
                  </>
                );
              }
            }
            return <div key={_ele?.id} className="apply-box">
              <div className="box-title">
                <p>单号：<span>{_ele?.no}</span></p>
                <p>{formatStatus(_ele[urlObj.status])}</p>
              </div>
              <div className="box-content">
                <div className="content-text">
                  <h2>￥{fmoney(_ele?.finalAmount, 2)}</h2>
                </div>
                <div className="content-icon" onClick={() => {
                  goto("/order/orderDetail", { loanid: _ele?.encLoanId, no:_ele.no })
                }}></div>
              </div>
              <div className="box-btn">
                {renderButton}
              </div>
            </div>
          })
        }
      </div>
    </CustomScroll>
    {showModel.show && <div className="model-box">
      <div className="model-dx">
        <div className="min-cont">{showModel.content}</div>
        {(!showModel.isSolo) && <div className="btn" onClick={() => { setShowModel({ show: false }) }}>我知道了</div>}
        {showModel.isSolo && <div className="btnz">
          <div onClick={() => { setShowModel({ show: false }) }}>取消</div>
          <div onClick={() => {
            Toast.show({
              icon: 'loading',
              content: '加载中…',
              duration: 0,
              maskClickable: false
            })
            loadReason("/api/loaning/reApply", {
              loaningInfoId: showModel.isSolo,
            }).then((res: any) => {
              Toast.clear()
              if (res.errcode == 0) {
                getList();
              } else {
                Toast.show(res?.errmsg || '操作异常')
              }
            }).catch((err) => {
              Toast.show(err?.errmsg || '操作异常')
            })
            setShowModel({ show: false })
          }}>确认</div>
        </div>}
      </div>
    </div>}
  </div>)
}

export default memo(FinanSchedule);